<template>
  <content-block title="报价明细">
    <TableWithPagination
      :tableData="list" row-key="index"
      :editConfig="{ trigger: 'munal', mode: 'cell' }"
      :mergeCells="[{row: 0, col: 2, rowspan: 3, colspan: 0}]"
      :columnList="columnList"
      size="mini"/>
  </content-block>
</template>
<script>
import TableWithPagination, { TablePaginationMixin } from '@/components/common/TableWithPagination';
export default {
  mixins: [TablePaginationMixin],
  components: {
    TableWithPagination,
  },
  props: {
    edit: {
      type: Boolean,
      default: false,
    },
    quotationDetail: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      list: [],
    };
  },
  watch: {
    quotationDetail: {
      deep: true,
      immediate: true,
      handler (val) {
        this.list = [
          {
            label: '人工',
            amount: this.calcLabourAmount(), // val.labourAmount
          },
          {
            label: '备件',
            amount: this.calcSparePartAmount(), // val.sparePartAmount
          },
          {
            label: '运费及其他',
            amount: val.transportationAmount || '',
          },
        ];
      },
    },
  },
  computed: {
    columnList () {
      return [
        {
          tooltip: true,
          label: '计费项',
          prop: 'label',
          width: '240px',
        },
        {
          tooltip: true,
          label: '金额',
          prop: 'amount',
          width: '240px',
          render: (h, { row }) => {
            let result = [];
            if (this.edit && row.label === '运费及其他') {
              result.push(
                <el-input-number v-model={row.amount} min={0} precision={2} controls={false} onChange={val => this.handleRowChange(val, row)} placeholder='请输入金额'></el-input-number>,
              );
            } else {
              result.push(row.amount);
            }
            return h('div', result);
          },
        },
        {
          tooltip: true,
          label: '合计（元）',
          prop: 'totalAmount',
          render: (h) => {
            let result = [];
            let totalAmount = 0;
            this.list.map(item => {
              totalAmount = totalAmount + Number(item.amount);
            });
            result.push(<b>{totalAmount > 0 ? totalAmount : ''}</b>);
            return h('div', result);
          },
        },
      ];
    },
  },
  methods: {
    calcLabourAmount () {
      if (this.quotationDetail?.itemList?.length) {
        let total = 0;
        this.quotationDetail.itemList.map(item => {
          if (['MAINTAIN', 'TEST'].includes(item.operationType)) {
            total = total + item.price * item.quantity;
          }
        });
        return total.toFixed(2);
      }
      return '';
    },
    calcSparePartAmount () {
      if (this.quotationDetail?.itemList?.length) {
        let total = 0;
        this.quotationDetail.itemList.map(item => {
          if (['CHANGE'].includes(item.operationType)) {
            total = total + item.price * item.quantity;
          }
        });
        return total.toFixed(2);
      }
      return '';
    },
    handleRowChange (val, row) {
      const detail = this.quotationDetail;
      detail.transportationAmount = row.amount;
      this.$emit('update:quotationDetail', detail);
    },
  },
};
</script>
